import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import "./Pagination.css";
const Pagination = ({ currentPage = 1, setCurrentPage }) => {
  return (
    <div className="page-main">
      <div  className="page-section">
        <div data-tour="navigate-records" style={{minWidth:"200px",minHeight:"200px"}} className="pagination">
          <button
            className="greyButton"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            <FaLessThan />
          </button>
          <span className="pagination-button">{currentPage}</span>
          <button
            className="greyButton"
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            {" "}
            <FaGreaterThan />{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;